<template>
  <vs-popup class="comments" title="会話" background-color="primary" :active.sync="popupActive" @close="$emit('onClose')">
    <!--        hard contents -->
    <div class="w-full flex charge-admin-control">
      <label class="text-sm opacity-75">状態<span class="text-danger">*</span></label>
      <v-select class="w-full" clearable :dir="$vs.rtl ? 'rtl' : 'ltr'" label="text" :searchable="false" :reduce="item => item.value"
                :options="faqStateOptions" v-model="chargeAdminModel.state">
        <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
      </v-select>
    </div>
    <div class="w-full flex charge-admin-control">
      <label class="text-sm opacity-75">担当者</label>
      <v-select class="w-full" :options="chargeAdminOptions" clearable :dir="$vs.rtl ? 'rtl' : 'ltr'"  :searchable="false" :reduce="item => item.id"
                label="name" v-model="chargeAdminModel.charge_admin_id">
        <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
      </v-select>
    </div>
    <div class="w-full flex charge-admin-actions">
      <vs-button color="danger" class="mr-2" @click="onDelNewIcon">NEWを消す</vs-button>
      <vs-button color="primary" icon="edit" class="mr-2" @click="onSaveFaqPost">更新</vs-button>
    </div>

    <vs-card class="left">
      <div slot="header">
        <h3 class="pl-2 mb-2">{{ faqSelectedItem ? faqSelectedItem.title : '' }}</h3>
        <div class="author">
          <div class="avatar">
              <img v-if="faqSelectedItem && faqSelectedItem.user_profile_data" :src="faqSelectedItem.user_profile_data">
              <vs-avatar v-else />
          </div>
          <h3 class="author-name">
            {{ faqSelectedItem ? faqSelectedItem.username : '' }}
          </h3>
          <h3 class="date-modified">
            {{ faqSelectedItem ? faqSelectedItem.created_at: '' }}
          </h3>
        </div>
      </div>
      <div class="content pl-2" >
        <span v-show="true" v-html="faqSelectedItem ? faqSelectedItem.content: ''"></span>
      </div>

      <div slot="footer" v-if="faqSelectedItem && faqSelectedItem.attachments && faqSelectedItem.attachments.length">
        <div class="mail-attachments">
          <vs-row vs-justify="flex-start" vs-align="center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F86F5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip font-medium-1 me-50"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
            <h5 class="fw-bolder text-body ml-1">添付ファイル</h5>
          </vs-row>
          <vs-row  v-if="faqSelectedItem && faqSelectedItem.attachments && faqSelectedItem.attachments.length" class="mt-2 attachment-list" vs-justify="flex-start" vs-align="center">
            <div>
              <a href="javascript:void(0)" @click="() => onDownloadAttachment(item.id)" class="mb-50 ml-1 filename" v-for="(item, index) in faqSelectedItem.attachments" :key="index">
                <img :src="require('@/assets/images/file-icons/download.svg')" class="me-25" alt="png" height="12">
                <span class="font-weight-bolder align-text-top ml-1">{{ item.file_name }}</span>
              </a>
            </div>
          </vs-row>
        </div>
      </div>
    </vs-card>
    <vs-divider />
    <!--        end hard contents-->
    <div v-if="faqSelectedItem && !faqSelectedItem.author_type" class="conversation" v-for="(item, index) in commentListCustom" :key="index">
      <vs-card class="right">
        <div slot="header">
          <div class="author">
            <div class="avatar">
                <img v-if="item && item.user_profile_data" :src="item.user_profile_data">
                <vs-avatar v-else />
            </div>
            <h3 class="author-name">
              {{ item.username }}
            </h3>
            <h3 class="date-modified">
              {{ item.created_at }}
            </h3>
          </div>
        </div>
        <div class="content pl-2" >
          <span style="white-space: pre-line" v-show="!item.editing" v-html="item.content"></span>
          <vs-textarea
              v-show="item.editing"
              v-model="editingMessage"
          />
        </div>

        <div slot="extra-content">
          <div class="upload-btn-wrapper update pl-5">
            <button class="btn mr-2" v-show="item.editing">添付ファイル</button>
            <input v-if="item.editing" type="file" multiple  @change="previewUpdateFiles"/>
          </div>
        </div>
        <div class="mail-attachments mt-10" v-if="item.attachments && (item.attachments.length || updateFiles.length)">
          <vs-row class="ml-1" vs-justify="flex-start" vs-align="center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F86F5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip font-medium-1 me-50"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
            <h5 class="fw-bolder text-body ml-1">添付ファイル</h5>
          </vs-row>
          <vs-row class="mt-2 attachment-list" vs-justify="flex-start" vs-align="center">
            <div>
              <a href="javascript:void(0)" v-show="!item.editing" @click="() => onDownloadAttachment(file.id)" class="mb-50 ml-1 filename" v-for="(file, fileIndex) in item.attachments" :key="fileIndex">
                <img :src="require('@/assets/images/file-icons/download.svg')" class="me-25" alt="png" height="12">
                <span class="font-weight-bolder align-text-top ml-1">{{ file.file_name }}</span>
              </a>
              <a href="javascript:void(0)" v-show="item.editing" class="mb-50 ml-1" v-for="(file, fileIndex) in item.attachments" :key="`update-${fileIndex}`">
                <span class="font-weight-bolder align-text-top ml-1">{{ file.file_name }}</span>
                <feather-icon @click="() => onDeleteAttachment(item, file.id)" icon="XCircleIcon" svgClasses="ml-2 h-5 w-5 text-danger cursor-pointer" />
              </a>

              <a href="javascript:void(0)" v-if="item.editing && updateFiles" class="mb-50 ml-1" v-for="(file, fileIndex) in updateFiles" :key="`new-${fileIndex}`">
                <span class="font-weight-bolder align-text-top ml-1">{{ file.name }}</span>
                <feather-icon @click="() => onDeleteLocalAttachment('update', fileIndex)" icon="XCircleIcon" svgClasses="ml-2 h-5 w-5 text-danger cursor-pointer" />
              </a>
            </div>
          </vs-row>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button v-if="!item.editing" color="primary" icon="edit" class="mr-2" @click="() => onEditMessage(item)">編集</vs-button>
            <vs-button v-else color="success" icon="save" class="mr-2" @click="onSaveMessage(item)">保存</vs-button>
            <vs-button color="danger" icon="delete" @click="onDeleteMessage(item)">削除</vs-button>
          </vs-row>
        </div>
      </vs-card>
    </div>
    <vs-divider v-show="faqSelectedItem && !faqSelectedItem.author_type && commentList && commentList.length"/>
    <div v-if="faqSelectedItem && !faqSelectedItem.author_type" class="message">
      <vs-textarea
        v-model="contentMessage"
        rows="6"
      />
    </div>
    <div class="mail-attachments mt-10" v-if="faqSelectedItem && !faqSelectedItem.author_type && newFiles.length">
      <vs-row class="ml-1" vs-justify="flex-start" vs-align="center">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F86F5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip font-medium-1 me-50"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
        <h5 class="fw-bolder text-body ml-1">添付ファイル</h5>
      </vs-row>
      <vs-row class="mt-2 attachment-list" vs-justify="flex-start" vs-align="center">
        <div>
          <a href="javascript:void(0)" v-if="newFiles" class="mb-50 ml-1" v-for="(file, fileIndex) in newFiles" :key="`newitem-${fileIndex}`">
            <span class="font-weight-bolder align-text-top ml-1">{{ file.name }}</span>
            <feather-icon @click="() => onDeleteLocalAttachment('new', fileIndex)" icon="XCircleIcon" svgClasses="ml-2 h-5 w-5 text-danger cursor-pointer" />
          </a>
        </div>
      </vs-row>
    </div>
    <vs-row v-if="faqSelectedItem && !faqSelectedItem.author_type">
        <vs-col vs-w="6" class="upload-btn-wrapper">
          <button class="btn mr-2">添付ファイル</button>
          <input type="file" multiple  @change="previewFiles"/>
        </vs-col>
        <vs-col vs-w="6">
          <vs-button color="primary" type="flat" icon="send" class="send-button float-right" style="background-color: #FFFFFF!important;" @click="sendNewMessage"></vs-button>
        </vs-col>
    </vs-row>
  </vs-popup>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import {faqState} from "@/enums/faqBbs";
const faqBbsModule = createNamespacedHelpers('faqBbs')

export default {
  props: {
    popupActive: { type: Boolean, default: false },
    faqSelectedItem: { type: Object, default: {} },
  },
  data() {
    return {
      contentMessage: '',
      editingId: '',
      editingMessage: '',
      newFiles: [],
      updateFiles: [],
      commentListCustom: [],
      chargeAdminModel: {
        state: null,
        charge_admin_id: null,
      },
    }
  },
  computed: {
    ...faqBbsModule.mapState(['commentList', 'chargeAdminList']),
    faqStateOptions() {
      return faqState
    },
    chargeAdminOptions() {
      return [{id: null, name: "アイテムを選択してください"}, ...this.chargeAdminList]
    }
  },
  methods:{
    ...faqBbsModule.mapActions([
      'createFaqBbsComment',
      'createFaqBbsCommentAttachment',
      'fetchFaqBbsCommentList',
      'updateFaqBbsComment',
      'deleteFaqBbsComment',
      'downloadFaqBbsAttachment',
      'deleteFaqBbsCommentAttachment',
      'updateFaqBbs',
      'deleteFaqBbsNewIcon',
    ]),
    onDownloadAttachment(attachmentId) {
      if(!attachmentId) return
      this.downloadFaqBbsAttachment(attachmentId)
    },
    async onDeleteAttachment(comment, attachmentId) {
      if(!attachmentId || !comment) return
      const data = { attachment_ids: [attachmentId] }
      const res = await this.deleteFaqBbsCommentAttachment({ commentId: comment.id, data })
      if (res && comment.attachments) {
        comment.attachments.splice(comment.attachments.findIndex(item => item.id === attachmentId), 1)
      }
    },
    onDeleteLocalAttachment(type, fileIndex) {
      if (type === 'update') {
        this.updateFiles.splice(fileIndex, 1)
      } else {
        this.newFiles.splice(fileIndex, 1)
      }

    },
    previewFiles(event) {
      if(!event.target.files) return
      this.newFiles.push(...Array.from(event.target.files))
      event.target.value = ''
    },
    previewUpdateFiles(event) {
      if(!event.target.files) return
      this.updateFiles.push(...Array.from(event.target.files))
      event.target.value = ''
    },
    onEditMessage(comment) {
      if (!comment || !comment.id) return
      this.commentListCustom = this.commentListCustom.map(item => {
        item.editing = false
        if(item.id === comment.id) {
          item.editing = true
        }
        return item
      })
      this.updateFiles = []
      this.editingMessage = comment.content
      this.editingId = comment.id
    },
    async onDeleteMessage(comment) {
      if (!comment || !comment.id) return
      if (!this.faqSelectedItem || !this.faqSelectedItem.id) return
      const res = await this.deleteFaqBbsComment(comment.id)
      if (res) await this.fetchFaqBbsCommentList(this.faqSelectedItem.id)
    },
    async onSaveMessage(comment) {
      if (!comment || !comment.id) return
      if (!this.editingMessage) return
      if (!this.editingId) return
      if (!this.faqSelectedItem || !this.faqSelectedItem.id) return
      const commentData = {
        content: this.editingMessage,
      }
      const res = await this.updateFaqBbsComment({ commentId: this.editingId, payload: commentData })
      if (res && this.updateFiles && this.updateFiles.length) {
        const postData = new FormData()
        for (const file of this.updateFiles) {
          postData.append("files[]", file)
        }
        const commentAttachment = await this.createFaqBbsCommentAttachment({ commentId: this.editingId, data: postData})
      }
      await this.fetchFaqBbsCommentList(this.faqSelectedItem.id)
      comment.editing = false
      this.editingMessage = ''
      this.updateFiles = []
    },
    async sendNewMessage() {
      if (!this.contentMessage) return
      if (!this.faqSelectedItem || !this.faqSelectedItem.id) return
      const commentData = {
        bbs_id: this.faqSelectedItem.id,
        content: this.contentMessage,
      }
      const commentId = await this.createFaqBbsComment(commentData)
      if (commentId && this.newFiles && this.newFiles.length) {
        const postData = new FormData()
        for (const file of this.newFiles) {
          postData.append("files[]", file)
        }
        const commentAttachment = await this.createFaqBbsCommentAttachment({ commentId, data: postData})
      }
      await this.fetchFaqBbsCommentList(this.faqSelectedItem.id)
      this.$emit('sent');
      this.contentMessage = ''
      this.newFiles = []
    },
    async onSaveFaqPost() {
      if (!this.faqSelectedItem ||!this.faqSelectedItem.id) return
      const faqData = {
        bbs_category_id: this.faqSelectedItem.bbs_category_id,
        title: this.faqSelectedItem.title,
        content: this.faqSelectedItem.content,
        view_type: this.faqSelectedItem.view_type,
        notify_type: this.faqSelectedItem.notify_type,
        state: this.chargeAdminModel.state,
        charge_admin_id: this.chargeAdminModel.charge_admin_id,
      }
      const result = await this.updateFaqBbs({id: this.faqSelectedItem.id, faqData})
    },
    async onDelNewIcon(){
      // alert(this.faqSelectedItem.id);
      await this.deleteFaqBbsNewIcon(this.faqSelectedItem.id);
      this.$emit('deleteFaqBbsNewIcon');
    }
  },
  watch: {
    faqSelectedItem: function (val) {
      if (val) {
        this.chargeAdminModel.state = +val.state
        this.chargeAdminModel.charge_admin_id = val.charge_admin_id
      }
    },
    commentList: function (val) {
      if (!val) {
        this.commentListCustom = []
        return
      }
      this.commentListCustom = this.commentList.map(item => {
        const _item = Object.assign({}, item)
        _item.editing = false
        _item.editable = true
        return _item
      })
    }
  }
}
</script>
<style lang="scss">
.comments {
  font-size: 14px;
  .author {
    .avatar {
      float: left;
      img {
        width: 50px;
        height: 50px;
        object-fit: contain;
        object-position: center;
      }
    }

    .author-name {
      font-size: 14px;
      padding-top: 5px;
      padding-bottom: 2px;
    }

    .date-modified {
      font-size: 13px;
      color: #8c8c8c;
    }
  }
  .content {
    overflow-wrap: break-word;
  }
  .attachment-list {
    div {
      width: 100%;
      margin-bottom: 0.5rem;
      a {
        display: flex;
        align-items: center;
      }
    }
  }

  .con-upload {
    .con-input-upload, .img-upload {
      width: 100px !important;
      height: 50px !important;
    }

    .text-archive {
      word-break: break-all;
      font-size: 8px;
    }

    .text-input {
      color: #2c2c2c;
    }

    .con-img-upload {
      padding-left: 0;
      padding-top: 0;
    }

    .con-input-upload, .img-upload {
      margin-left: 0;
      margin-top: 0;
    }
  }

  .message {
    position: relative;

    .vs-textarea {
      background: #fff;
    }

    .send-button {
      background: transparent !important;
      position: absolute;
      bottom: 0;
      right: 0;

      &.isActive {
        background: transparent !important;
      }

      .vs-button-backgroundx.vs-button--background {
        opacity: 0 !important;
      }
    }
  }

  .vs-card-extra--content {
    .vs-button {
      &.attachment {
        padding: 0;
        background: transparent !important;

        .vs-button-backgroundx.vs-button--background {
          opacity: 0 !important;
        }
      }
    }

  }

  .vs-card--content {
    font-size: 14px;
    .filename:hover {
      color: #0F86F5;
    }
  }
  .vs-card--footer {
    border-top: 1px solid #dae1e7;
    padding-top: 1rem;
    margin-top: .5rem;
    .filename:hover {
      color: #0F86F5;
    }
  }

  .vs-popup--content {
    padding: 1rem 2rem !important;

    .con-vs-card {
      border: 2px solid #0F86F5;
      position: relative;

      &.left:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 11px solid;
        border-color: transparent #0F86F5 transparent transparent;
        left: -23px;
        bottom: 10px;
      }

      &.left:after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid;
        border-color: transparent #FFF transparent transparent;
        left: -20px;
        bottom: 11px;
      }

      &.right:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 11px solid;
        border-color: transparent transparent transparent #0F86F5;
        right: -23px;
        bottom: 10px;
      }

      &.right:after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid;
        border-color: transparent transparent transparent #FFF;
        right: -20px;
        bottom: 11px;
      }
    }
  }

  .vs-card--footer {
    transform: none;
  }

  .view-upload {
    z-index: 999999;
  }

  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;

    .btn {
      border: 1px solid gray;
      color: gray;
      background-color: white;
      padding: 4px 20px;
      border-radius: 4px;
    }

    .btn[disabled] {
      color: #bfbfbf;
      border-color: #bfbfbf;
    }

    input[type=file] {
      font-size: 100px;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }
  .charge-admin-control {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    label {
      width: 100px;
    }
  }
  .charge-admin-actions {
    justify-content: right;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
}

</style>
